import React, { useState, useEffect, useContext, Fragment } from "react";
import HomePageNavbar from "../../components/navbars/HomePageNavbar";
import $ from "jquery";
import { Accordion, Col, Container, Image, Row } from "react-bootstrap";
import "./homePage.css";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import Schedule from "../schedule/Schedule";
import ContactData from "../../components/ContactData";
import { postMethod } from "../../requests";
import { BasicContext } from "../../App";
import { useNavigate } from "react-router-dom";
import RedirectModal from "../../components/modals/RedirectModal";

const HomePage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const myVideo = document.getElementById("mainVideo");
    const myVideoMobile = document.getElementById("mainVideoMobile");
    const [mobile, setMobile] = useState(null);
    const { checkServerData } = useContext(BasicContext);
    const [showRedirectModal, setShowRedirectModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading) {
            myVideo.play();
            /* $("#mainLogo").delay(800).fadeOut(300);
            setTimeout(() => { */
            myVideoMobile.play();
            /* }, 1100); */
        }
        // eslint-disable-next-line
    }, [loading]);

    const showVideo = () => {
        if (window.outerHeight > window.outerWidth) {
            setMobile(true);
            $("#mainVideo").fadeOut(0);
            $("#mainVideoMobile").fadeIn(0);
            /* $("#mainLogo").fadeIn(0);
            $("#mainLogo").delay(600).fadeOut(300); */
        } else {
            setMobile(false);
            $("#mainVideoMobile").fadeOut(0);
            //$("#mainLogo").fadeOut(0);
            $("#mainVideo").fadeIn(0);
        }
    };

    const checkIfRedirectToApp = async () => {
        const res = await postMethod("/check-if-redirect-to-app");
        if (checkServerData(res)) {
            if (res.data.list.length > 1) setShowRedirectModal(res.data.list);
            else if (res.data.list.length === 1) {
                if (res.data.list[0] === "APP_LOGIN") navigate("/app");
                else if (res.data.list[0] === "ADMIN_APP_LOGIN") navigate("/admin-app");
            }
        }
    };

    useEffect(() => {
        checkIfRedirectToApp();

        if (window.outerHeight > window.outerWidth) {
            $("#mainVideoMobile").fadeIn(0);
            $("#mainLogo").fadeIn(0);
        } else $("#mainVideo").fadeIn(0);

        window.addEventListener("resize", showVideo);

        setTimeout(() => {
            $("#loadingView").fadeOut(500);
            setTimeout(() => {
                setLoading(false);
            }, 600);
        }, 1500);

        $(document).ready(function () {
            $(window).on("scroll", function () {
                $(".class-circle-hover").each(function () {
                    const el = $(this);
                    if ($(window).scrollTop() + $(window).height() >= el.offset().top + 150) {
                        el.animate({ opacity: 1 }, 500);
                    }
                });
                $(".class-txt").each(function () {
                    const el = $(this);
                    if (
                        $(window).scrollTop() + $(window).height() >=
                        (window.outerHeight > window.outerWidth ? el.offset().top - 900 : el.offset().top + 200)
                    ) {
                        el.addClass("show");
                    }
                });
            });
        });

        return () => {
            window.removeEventListener("resize", showVideo);
        };
        // eslint-disable-next-line
    }, []);

    const classesTypes = [
        {
            src: "/images/class_grip.webp",
            title: t("homePage.poleDance"),
            text: t("homePage.poleDanceTxt"),
        },
        {
            src: "/images/class_heel.webp",
            title: t("homePage.poleExotic"),
            text: t("homePage.poleExoticTxt"),
        },
        {
            src: "/images/class_stretch.webp",
            title: t("homePage.stretching"),
            text: t("homePage.stretchingTxt"),
        },
        {
            src: "/images/class_flow.webp",
            title: t("homePage.poleFlow"),
            text: t("homePage.poleFlowTxt"),
        },
        {
            src: "/images/class_strength.webp",
            title: t("homePage.strength"),
            text: t("homePage.strengthTxt"),
        },
        {
            src: "/images/class_mobility.webp",
            title: t("homePage.mobility"),
            text: t("homePage.mobilityTxt"),
        },
    ];

    const instr = [
        {
            src: "/images/ola",
            alt: "Zdjęcie Aleksandry Kaźmierczak",
            title: "Ola Kaźmierczak",
            text: "Miłośniczka sportu i zdrowego stylu życia. Od 4 lat pasjonuje się pole dance. Jako certyfikowana trenerka pole dance, z radością dzieli się swoją wiedzą i doświadczeniem, pomagając innym odkrywać ich potencjał i pewność siebie. Na zajęciach stawia na atmosferę wsparcia i motywacji, wierząc, że taniec to nie tylko trening, ale także sposób na wyrażanie samej siebie.",
            insta: "https://www.instagram.com/aleksi_xo/",
        },
        /*  {
            src: "/images/daria",
            alt: "Zdjęcie Darii Kluczyńskiej",
            title: "Daria Kluczyńska",
            text: "Zakochana w pole dance od 5 lat, łączy siłę na statyku z gracją i emocjami na spinie przy dźwiękach klasyki. Certyfikowana instruktorka po szkoleniach w Dobrym Polu i Akademii Sway. Uwielbia taniec, muzykę, sport i sztukę. Prywatnie łączy treningi z pracą nauczycielki, fotografią, malowaniem i siłownią. Pole dance to dla niej pasja pełna gracji i emocji.",
            insta: "https://www.instagram.com/darkakadarka_ph/",
        }, */
        {
            src: "/images/eliza",
            alt: "Zdjęcie Elizy Więckowskiej",
            title: "Eliza Więckowska",
            text: "Certyfikowana instruktorka rozciągania (kurs Anastasii Lutai) i pole dance (Akademia Sway). Miłość do sportu odkryła w wieku 28 lat, gdy spróbowała pole dance. Finalistka zawodów Poledanceholic, PinUp Competition i Pole Dance Show. Poza salą zajmuje się fotografią, więc możecie spotkać ją na rurkowych sesjach z aparatem w ręku.",
            insta: "https://www.instagram.com/elizawieck/",
        },
        /* {
            src: "/images/elwira",
            alt: "Zdjęcie Elwiry Fabrowskiej",
            title: "Elwira Fabrowska",
            text: "Sport towarzyszy jej od zawsze. Po zakończeniu przygody z jeździectwem znalazła pasję w pole dance, którą trenuje od 2018 roku. Uwielbia spin, lekkość i płynność ruchu, przekraczanie granic oraz wyrażanie emocji w tańcu. Jako magister fizjoterapii dba o bezpieczeństwo i rozwój uczestników. Stale doskonali się na szkoleniach i warsztatach.",
            insta: "https://www.instagram.com/made.my.day/",
        }, */
        {
            src: "/images/klaudia",
            alt: "Zdjęcie Klaudii Jakubowskiej",
            title: "Klaudia Jakubowska",
            text: "Certyfikowana instruktorka, związana z pole dancem od 2019 roku. Specjalizuje się w rurce statycznej, siłowych elementach i dynamicznych przejściach, ale tworzy też piękne combosy na rurce obrotowej. Klaudia dba o indywidualne podejście, technikę i wzmocnienie ciała. Ukończyła szkolenia w Akademii Sway i Pro Calisthenics Academy.",
            insta: "https://www.instagram.com/jakubowska_klaudiaa/",
        },
        {
            src: "/images/kuba",
            alt: "Zdjęcie Kuby Giela",
            title: "Kuba Giel",
            text: "Certyfikowany trener przygotowania fizycznego, absolwent szkoły SCEC w Gdyni. Prowadzi treningi grupowe i indywidualne, a w Pole Therapy zajęcia wzmacniające siłę i wytrzymałość kursantek. Trenuje olimpijskie podnoszenie ciężarów, a doświadczenie w pole dance pomaga mu lepiej dostosować treningi do potrzeb sportowców z tej dyscypliny.",
            insta: "https://www.instagram.com/strengthmade_athletics/",
        },
        /* {
            src: "/images/monika",
            alt: "Zdjęcie Moniki Żak",
            title: "Monika Gruszka-Żak",
            text: "Pole dance trenuje od ponad 4 lat, zakochana w szybkim spinie i dynamicznych choreografiach. Wyznaje zasadę, że każde wyzwanie można opanować z czasem. Na zajęciach zapewnia masę pozytywnej energii. Ukończyła kurs instruktora Pole Dance Basic (Dobre Pole) i szkolenie z prowadzenia exo na poziomie podstawowym u Magdaleny Marycz.",
            insta: "https://www.instagram.com/gruszka_pietruszkaa",
        }, */
        {
            src: "/images/sabrina",
            alt: "Zdjęcie Sabriny Pińskiej",
            title: "Sabrina Pińska",
            text: "Certyfikowana instruktorka pole dance, stretchingu oraz rekreacji ruchowej z kilkuletnim doświadczeniem. Rurka zawróciła jej w głowie w 2018 r. i od tego czasu, nie licząc krótkich przerw, jest nieodłączną częścią jej życia. Uwielbia zarażać innych swoją pasją, prowadząc zajęcia w miłej, swobodnej i wspierającej atmosferze, a przy tym dbając o bezpieczeństwo kursantów.",
            insta: "https://www.instagram.com/sabisajgon/",
        },
        {
            src: "/images/jagoda",
            alt: "Zdjęcie Jagody Wesołowskiej",
            title: "Jagoda Wesołowska",
            text: "Certyfikowana instruktorka, która swoją pasję do Pole Dance odkryła w 2021 roku. Preferuje rurkę obrotową, która pozwala jej łączyć technikę z estetyką ruchu, nadając każdej figurze lekkości i gracji. Chętnie podejmuje też wyzwania na rurce statycznej. Na jej zajęciach panuje ciepła, wspierająca atmosfera, a kursantki mogą liczyć na bezpieczeństwo i indywidualne wsparcie. Ukończyła szkolenia w Akademii Sway.",
            insta: "https://www.instagram.com/wesolowska_jagoda/",
        },
        {
            src: "/images/zuza",
            alt: "Zdjęcie Zuzanny Kliks",
            title: "Zuzanna Kliks",
            text: "Certyfikowana instruktorka pole dance (Pole Physio Szkolenia), która lubi poszerzać swoją wiedzę oraz umiejętności na różnych szkoleniach (ABC dynamiki Akademia Sway) oraz warsztatach. Związana z rurką od końcówki 2021 roku. Na codzień IT girl, pasjonatka aktywnego spędzania czasu wolnego w naturze oraz gry na gitarze. Lubi dynamikę na rurce statycznej, ale krewetkowe wykrętasy na spinie też nie są jej obce.",
            insta: "https://www.instagram.com/zuza.kliks",
        },
    ];

    const faq = [
        {
            header: "Jak zapisać się na zajęcia?",
            body: "Na początek zarejestruj się na naszej stronie. Po utworzeniu konta i zalogowaniu się, wybierz interesujące Cię zajęcia oraz karnet. Opłać zajęcia i gotowe 🙂 Jeśli jesteś nowym klientem - Twoje konto będzie wymagało aktywacji - napisz do nas w tej sprawie.",
        },
        {
            header: "Czy jest możliwość wydłużenia karnetu?",
            body: "Nie. Karnety nie podlegają zamrożeniu czy wydłużeniu. Od tej reguły nie ma wyjątku 🙂 Jeśli nie jesteś w stanie zrealizować standardowych karnetów w 30 dni - zachęcamy do wyboru unikalnego karnetu na 5 wejść, który jako JEDYNY jest ważny 60 dni.",
        },
        {
            header: "Czy karnet mogę wykorzystać tylko na zajęcia Pole Dance?",
            body: "Nie 🙂 Posiadamy różne rodzaje karnetów odpowiadającym kategoriom zajęć. Najpopularniejsze karnety możesz wykorzystać dowolnie tak jak lubisz - na wszystkie zajęcia grupowe w grafiku (stretching, wzmacnianie, open pole, pole flow czy exotic).",
        },
        {
            header: "Co zrobić kiedy nie mogę przyjść na zajęcia?",
            body: "Po zalogowaniu się na naszej stronie, kliknij w ikonkę „zapisane zajęcia” a następnie anuluj wybrane daty, by zwolnić swoje miejsce dla innych koleżanek. Pamiętaj, by wypisać się najpóźniej 24h przed zajęciami - będziesz je mogła wtedy odrobić w innym terminie. W przeciwnym razie zajęcia są traktowane jako odbyte (wejście z karnetu przepada, a w przypadku nieopłaconych zajęć jest konieczność ich opłacenia).",
        },
        {
            header: "Czy mogę wykorzystać mój karnet wcześniej niż raz w tygodniu?",
            body: "Oczywiście! Karnety nie mają ograniczeń tygodniowych. Jeśli masz ochotę, możesz wszystkie wejścia z karnetu wykorzystać nawet w jeden tydzień 🙂",
        },
        {
            header: "Czy honorujecie karty partnerskie typu Multisport?",
            body: "Nie honorujemy kart partnerskich. Stawiamy na jakość treningu i kameralne grupy. Na naszych zajęciach jest maksymalnie 7 osób na zajęciach pole dance oraz 10 osób na zajęciach wzmacniających czy stretchingu.",
        },
        {
            header: "Jak mam się ubrać na zajęcia?",
            body: "Na zajęcia pole dance zabierz ze sobą krótkie spodenki, skarpetki i koszulkę z krótkim rękawkiem lub na ramiączkach. Odzież nie może posiadać wystających zamków, guzików, wystających elementów plastikowych lub metalowych. Nie wolno ćwiczyć w biżuterii. Zegarki, bransoletki, wiszące kolczyki są niedozwolone podczas zajęć. Na zajęcia stretchingu/wzmacniania zabierz wygodny strój sportowy i skarpetki.",
        },
        {
            header: "Czy wiek albo waga są przeciwwskazaniem do treningów pole dance?",
            body: "Absolutnie nie 🙂 Trenują u nas panie w każdym możliwym rozmiarze, kształcie i wieku (nawet po 60-tce!). Treningi pozwalają wysmuklić i wzmocnić ciało. Początki bywają trudne, ale nic tak nie cieszy jak progres z zajęć na zajęcia. W naszej ofercie są także zajęcia indywidualne - polecamy je osobom, które nie przepadają za zajęciami grupowymi lub potrzebują więcej czasu na naukę.",
        },
    ];

    return (
        <Fragment>
            <main id="homePage">
                <HomePageNavbar />
                <Container fluid className="">
                    <Row>
                        <Col className="px-0">
                            {/* <Image src="/images/pt_main_logo.webp" alt="pole therapy main logo" id="mainLogo" /> */}
                            <video playsinline muted="muted" loop id="mainVideoMobile" style={{ display: "none" }}>
                                <source src="/videos/pt_video_mobile_compressed.mp4" type="video/mp4" />
                            </video>
                            <video muted="muted" loop id="mainVideo" style={{ display: "none" }}>
                                <source src="/videos/pt_video_compressed.mp4" type="video/mp4" />
                            </video>
                        </Col>
                    </Row>
                </Container>
                <Container fluid style={{ marginTop: "-6px" }} id="classesInPT">
                    <Row>
                        <Col xs={12} className="">
                            <h1>{t("homePage.classesInPT")}</h1>
                            <p className="d-lg-none">{t("homePage.clickOnClass")}</p>
                        </Col>
                        <Col lg={6} xl={8} className="d-none d-lg-block">
                            <div id="werkaFixed"></div>
                        </Col>
                        <Col xs={12} lg={6} xl={4} className="class-types">
                            <Row>
                                {classesTypes.map((c, i) => (
                                    <Col xs={12} md={6} lg={12} key={i} className="text-center">
                                        <div className="position-relative pb-4">
                                            <div
                                                className="class-circle-hover"
                                                style={{ opacity: 0 }}
                                                id={`classCircleHover${i}`}
                                            >
                                                <span>{c.title}</span>
                                            </div>

                                            <Image src={c.src} alt={c.title} className="class-circle" />
                                            <div className="class-txt px-3" id={`classTxt${i}`}>
                                                {c.text}
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <div id="studio">
                    <div>
                        <Container fluid="xxl">
                            <Row>
                                <Col xs={12} className="text-center">
                                    <h2>{t("homePage.studio")}</h2>
                                    <p>{t("homePage.studioTxt")}</p>
                                    <a
                                        href="https://maps.app.goo.gl/jg5uE89tbt5aw7jS9"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-primary btn-lg mb-5"
                                        aria-label="Link redirecting to google maps"
                                    >
                                        {t("homePage.seeArrival")}
                                    </a>
                                </Col>
                                <Col xs={12}></Col>
                            </Row>
                        </Container>
                    </div>
                </div>
                <Container fluid id="instructors">
                    <Row>
                        <Col xs={12} xl={{ span: 10, offset: 1 }}>
                            <Row>
                                <Col xs={12}>
                                    <h3 id="instructorsTitle">{t("homePage.instructors")}</h3>
                                </Col>
                                <Col
                                    xs={12}
                                    md={{ span: 8, offset: 2 }}
                                    lg={{ span: 6, offset: 0 }}
                                    className="text-xl-center"
                                >
                                    <Image
                                        src="/images/werka3.webp"
                                        fluid
                                        id="instrWeri"
                                        className="rounded-circle"
                                        alt="werka siedząca przy rurce trzymająca się nóg uniesionych w kształcie nożyc"
                                    />
                                </Col>
                                <Col xs={12} md={{ span: 10, offset: 1 }} lg={{ span: 6, offset: 0 }} id="werkaDescr">
                                    <div className="text-center">
                                        <p className="title d-inline-block mb-0 align-middle">Weronika Kozanecka </p>
                                        <a
                                            href={`https://instagram.com/weronika.kozanecka`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-outline-primary btn-sm text-end d-inline-block mb-0 ms-3 align-middle"
                                            aria-label="Przejdź do konta Weroniki na instagramie"
                                        >
                                            <FontAwesomeIcon icon={faInstagram} />
                                        </a>
                                    </div>
                                    <div>
                                        <p>
                                            Założycielka Pole Therapy. Pełna entuzjazmu, kwalifikowana instruktor
                                            fitness, pole dance i stretchingu. Z pole dance ma styczność od 2014 roku i
                                            od tamtego czasu została całkowicie pochłonięta przez rurkę. Jest kreatywna
                                            i pracowita. Oprócz profesjonalnych kursów i szkoleń, regularnie doskonali
                                            swoje umiejętności na wielu warsztatach, dzięki czemu Kursanci mają
                                            gwarancję, że treningi są prowadzone w bezpieczny sposób.
                                        </p>
                                        <p>
                                            Ma za sobą szkolenia z pole dancerkami światowej sławy. Na jej zawodowym
                                            koncie znajdziemy takie osiągnięcia jak:
                                        </p>
                                        <ul>
                                            <li>I miejsce PoleDanceHolic 2024 kategoria Stars</li>
                                            <li>II miejsce AerialEmotion Slovakia 2024 kategoria Profesjonaliści</li>
                                            <li>III miejsce AerialEmotion Slovakia 2024 kategoria Pole Contemporary</li>
                                            <li>III miejsce Revolution Greece 2023 kategoria Profesjonaliści</li>
                                            <li>I miejsce PoleDanceHolic 2023 kategoria Stars</li>
                                            <li>III miejsce Pole Art Experience 2022 kategoria Pro i Elite</li>
                                            <li>I miejsce Pole Art Experience 2020 kategoria Pro & Elite</li>
                                            <li>III miejsce Pole Dance Fever 2019</li>
                                            <li>III miejsce Verticalfit Championship 2018</li>
                                            <li>I miejsce Sensual Championship 2017</li>
                                            <li>II miejsce Verticalfit Championship 2016</li>
                                            <li>Ćwierćfinalistka programu Mam Talent Polska 2019</li>
                                            <li>II miejsce Pole Art UK ELITE 2025</li>
                                            <li>II miejsce Pin Up Competition STARS 2025</li>
                                            <li>I miejsce Ritual Woman Champions PRO 2025</li>
                                            <li>I miejsce Pole Artistic Hungary PRO 2025</li>
                                            <li>
                                                III miejsce + nagroda specjalna Best Stage Presence w Sparkle
                                                Competition Italy ELITE 2025
                                            </li>
                                            <li>V miejsce Fusion Championship Stars 2025</li>
                                            <li>Finalistka Pole Art Italy ELITE 2025</li>
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} className="d-lg-none">
                                    <p>{t("homePage.clickOnInstr")}</p>
                                </Col>
                                {instr.map((e, i) => (
                                    <Col xs={12} md={6} lg={4} xxl={3} key={i}>
                                        <div
                                            className="instr-card my-3"
                                            onClick={() => $(`#instrCardBody${i}`).addClass("show")}
                                            onMouseOver={() => $(`#instrCardBody${i}`).addClass("show")}
                                            onMouseOut={() => $(`#instrCardBody${i}`).removeClass("show")}
                                        >
                                            <div className="instr-card-body" id={`instrCardBody${i}`}>
                                                <p className="instr-card-title d-inline-block">{e.title}</p>
                                                {e.insta && (
                                                    <a
                                                        href={e.insta}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="btn btn-outline-primary btn-sm text-end d-inline-block mb-3 ms-3"
                                                        aria-label={`Przejdź do konta instruktora ${e.title} na instagramie`}
                                                    >
                                                        <FontAwesomeIcon icon={faInstagram} />
                                                    </a>
                                                )}
                                                <p className="instr-card-text">{e.text}</p>
                                            </div>
                                            <Image
                                                src={mobile ? `${e.src}_mobile.webp` : `${e.src}.webp`}
                                                alt={e.alt}
                                                fluid
                                            />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <div id="schedule">
                    <Container>
                        <Row>
                            <Col xs={12}>
                                <h4>{t("schedule.schedule")}</h4>
                            </Col>
                            <Col xs={12} id="scheduleScroll">
                                <Schedule />
                            </Col>
                            <Col xs={12} className="text-center">
                                <a
                                    href={`${process.env.REACT_APP_URL}/app`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="my-4 btn btn-primary btn-lg"
                                    aria-label={t("schedule.signUpForClassAriaLabel")}
                                >
                                    {t("schedule.signUpForClass")}
                                </a>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div id="faq">
                    <Container>
                        <Row>
                            <Col xs={12}>
                                <h5>{t("faq")}</h5>
                            </Col>
                            <Col xs={12} lg={7}>
                                <Accordion className="mb-4">
                                    {faq.map((e, i) => (
                                        <Accordion.Item eventKey={i} key={i}>
                                            <Accordion.Header>{e.header}</Accordion.Header>
                                            <Accordion.Body>{e.body}</Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            </Col>
                            <Col xs={12} lg={5} className="d-none d-lg-block">
                                <Image
                                    fluid
                                    src="/images/ola2.webp"
                                    alt="Ola robiąca chest press'a przy rurce stając na rękach"
                                />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div id="contact">
                    <ContactData />
                </div>
            </main>

            {showRedirectModal && <RedirectModal onClose={() => setShowRedirectModal(false)} />}
        </Fragment>
    );
};

export default HomePage;
